/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Site header height as a CSS variable so sticky/full-viewport surfaces
 * (about journey, anchor scroll) sit flush under the AppBar.
 */

export const SITE_HEADER_HEIGHT_VAR = '--site-header-height';
export const SITE_HEADER_HEIGHT_FALLBACK = 70;

export function setSiteHeaderHeight(px: number) {
  document.documentElement.style.setProperty(SITE_HEADER_HEIGHT_VAR, `${Math.round(px)}px`);
}

export function readSiteHeaderHeight(): number {
  if (typeof window === 'undefined') return SITE_HEADER_HEIGHT_FALLBACK;
  const n = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue(SITE_HEADER_HEIGHT_VAR),
  );
  // Explicit 0 is valid (demo / chrome-less recordings). Unset → NaN → fallback.
  if (!Number.isFinite(n)) return SITE_HEADER_HEIGHT_FALLBACK;
  return Math.max(0, n);
}
